<template>
  <LcTable v-if="prizeTier" class="prize-tier-modal-table" padding="small">
    <thead>
      <tr class="text-secondary-secondary">
        <th>{{ $t('highfrequencygame.prizemodaltable.header.chance') }}</th>
        <th>
          {{
            $t('highfrequencygame.prizemodaltable.header.chancevalue', {
              value: prizeTier.overallChance,
            })
          }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="{ jackpot, matchCount, prize } in prizeTier.prizeTable" :key="matchCount">
        <td class="paragraph-bold">
          {{
            $t('highfrequencygame.prizemodaltable.body.match', {
              value: matchCount,
            })
          }}
        </td>
        <td>
          {{ formatPrizeMoney(prize) }}
          <template v-if="jackpot">
            {{ $t('tiertable.fielddivider') }} {{ $t('tiertable.jackpot') }}
          </template>
        </td>
      </tr>
    </tbody>
  </LcTable>
</template>

<script lang="ts" setup>
const { prizeTier } = useHighFrequencyGame()
const { formatPrizeMoney } = usePrizeMoneyFormatter()
</script>

<style lang="scss" scoped>
.prize-tier-modal-table {
  tr {
    @include token-paragraph-bold;

    th,
    td {
      &:last-child {
        text-align: right;
      }
    }
  }
}
</style>
